export default __webpack_public_path__ + "static/media/flag-2.2955a0e9.gif";